import axios from '../axios.js';

var api = {
  //获取精品课程
  getClass(){
    return axios.post('index/curriculum/list')
  },
  //老师列表
  teacherList(){
    return axios.post('index/user/teacherList')
  },
  //最新公开课
  getOpenClass(){
    return axios.post('index/curriculum/open')
  },
  //免费课
  freeClass(){
    return axios.post('index/curriculum/free')
  },
  // 换库时间
  config(){
    return axios.post('index/Config/list')
  }
}

export default api


// WEBPACK FOOTER //
// ./src/api/activeTest.js